export class OperationSearch {
  constructor (rechercheOperation) {
    this.login = rechercheOperation ? rechercheOperation.login : null
    this.entrepriseId = rechercheOperation ? rechercheOperation.entrepriseId : null
    this.groupName = rechercheOperation ? rechercheOperation.groupName : null
    this.periodId = rechercheOperation ? rechercheOperation.periodId : null
    this.entityId = rechercheOperation ? rechercheOperation.entityId : null
    this.selectedPeriod = rechercheOperation ? rechercheOperation.selectedPeriod : null
    this.entityLevel = rechercheOperation ? rechercheOperation.entityLevel : null
    this.parentEntityId = rechercheOperation ? rechercheOperation.parentEntityId : null
    this.highEntityId = rechercheOperation ? rechercheOperation.highEntityId : null
    this.fileToDownload = rechercheOperation ? rechercheOperation.fileToDownload : null
    this.keyFolder = rechercheOperation ? rechercheOperation.keyFolder : null
    this.beginIndex = rechercheOperation ? rechercheOperation.beginIndex : null
    this.endIndex = rechercheOperation ? rechercheOperation.endIndex : null
  }
}
export class OperationSearchForm {
  constructor (rechercheOperationForm) {
    this.dateDebPeriode = rechercheOperationForm ? rechercheOperationForm.dateDebPeriode : null
    this.dateFinPeriode = rechercheOperationForm ? rechercheOperationForm.dateFinPeriode : null
    this.nom = rechercheOperationForm ? rechercheOperationForm.nom : null
    this.prenom = rechercheOperationForm ? rechercheOperationForm.prenom : null
    this.numCarte = rechercheOperationForm ? rechercheOperationForm.numCarte : null
    this.agence = rechercheOperationForm ? rechercheOperationForm.agence : null
    this.compte = rechercheOperationForm ? rechercheOperationForm.compte : null
    this.montant = rechercheOperationForm ? rechercheOperationForm.montant : null
    this.typeOperation = rechercheOperationForm ? rechercheOperationForm.typeOperation : null
    this.entityId = rechercheOperationForm ? rechercheOperationForm.entityId : null
    this.beginIndex = rechercheOperationForm ? rechercheOperationForm.beginIndex : null
    this.endIndex = rechercheOperationForm ? rechercheOperationForm.endIndex : null
  }
}
export class OperationPorteurSearch {
  constructor (rechercheOperationPorteur) {
    this.dateDebut = rechercheOperationPorteur ? rechercheOperationPorteur.dateDebut : null
    this.dateFin = rechercheOperationPorteur ? rechercheOperationPorteur.dateFin : null
    this.format = rechercheOperationPorteur ? rechercheOperationPorteur.format : 'Bureautique'
    this.login = rechercheOperationPorteur ? rechercheOperationPorteur.login : null
    this.card = rechercheOperationPorteur ? rechercheOperationPorteur.card : null
    this.currentPersonne = rechercheOperationPorteur ? rechercheOperationPorteur.currentPersonne : null
    this.demo = rechercheOperationPorteur ? rechercheOperationPorteur.demo : null
  }
}
export class OperationsCartePorteurSearch {
  constructor (rechercheOperationsCartePorteur) {
    this.login = rechercheOperationsCartePorteur ? rechercheOperationsCartePorteur.login : null
    this.cardId = rechercheOperationsCartePorteur ? rechercheOperationsCartePorteur.cardId : null
    this.periodeId = rechercheOperationsCartePorteur ? rechercheOperationsCartePorteur.periodeId : null
  }
}
export class TelechargementOperations {
  constructor (telechargementOperations) {
    this.dateDebut = telechargementOperations ? telechargementOperations.dateDebut : null
    this.dateFin = telechargementOperations ? telechargementOperations.dateFin : null
    this.format = telechargementOperations ? telechargementOperations.format : 'Bureautique'
    this.selectedEntreprise = telechargementOperations ? telechargementOperations.selectedEntreprise : null
    this.loggedUserLogin = telechargementOperations ? telechargementOperations.loggedUserLogin : null
  }
}
